const translations = {
  // Nav
  "nav.home": "Home",
  "nav.mission": "Mission",
  "nav.projects": "Projects",
  "nav.stories": "Stories",
  "nav.volunteer": "Volunteer",
  "nav.donate": "Donate",
  "nav.contact": "Contact",
  "nav.donateNow": "Donate Now",

  // Language bar
  "lang.managed": "Managed via Admin CMS Dashboard",

  // Hero
  "hero.badge": "Building Bridges · Creating Hope",
  "hero.title": "Empowering Afghan Communities Through Education & Opportunity",
  "hero.subtitle": "The Canada Afghanistan Foundation connects compassionate Canadians with Afghan communities in need — funding education, healthcare, and sustainable development since 2016.",
  "hero.cta.donate": "Support Our Mission",
  "hero.cta.learn": "Learn Our Story",
  "hero.scroll": "Scroll",

  // Mission Preview
  "mission.tag": "Our Mission",
  "mission.title": "A Bridge Between Two Nations, Built on Compassion",
  "mission.body1": "The Canada Afghanistan Foundation (CAF) is a registered Canadian charity dedicated to improving the lives of Afghan people through targeted programs in education, healthcare, and community development.",
  "mission.body2": "We believe every Afghan child deserves access to education, every family deserves clean water, and every community deserves the chance to thrive — regardless of conflict or circumstance.",
  "mission.cta": "Read Our Full Mission",
  "mission.pillar.education": "Education",
  "mission.pillar.education.desc": "Funding schools, scholarships, and vocational training for Afghan youth and women.",
  "mission.pillar.healthcare": "Healthcare",
  "mission.pillar.healthcare.desc": "Deploying mobile clinics and supporting medical professionals in underserved regions.",
  "mission.pillar.community": "Community",
  "mission.pillar.community.desc": "Building infrastructure, clean water access, and supporting refugee resettlement in Canada.",
  "mission.pillar.sustainability": "Sustainability",
  "mission.pillar.sustainability.desc": "Empowering local leaders and organizations to create lasting, self-sufficient change.",

  // Projects Preview
  "projects.tag": "Active Initiatives",
  "projects.title": "Our Current Projects",
  "projects.subtitle": "Every project is carefully designed to create lasting impact in Afghan communities. Here's what we're working on right now.",
  "projects.viewAll": "View All Projects",
  "projects.learnMore": "Learn More",
  "projects.raised": "Raised",
  "projects.completed": "Completed",

  // Impact
  "impact.tag": "Our Impact",
  "impact.title": "Real Change, Real Numbers",
  "impact.subtitle": "Every dollar donated translates into measurable impact on the ground. Here's what we've achieved together.",
  "impact.students": "Students Supported",
  "impact.students.desc": "Girls and boys receiving quality education through our scholarship and school programs.",
  "impact.water": "People with Clean Water",
  "impact.water.desc": "Families in rural Afghanistan now have access to safe, clean drinking water.",
  "impact.medical": "Medical Consultations",
  "impact.medical.desc": "Free healthcare provided through our mobile clinic program since 2018.",
  "impact.families": "Families Resettled",
  "impact.families.desc": "Afghan refugee families supported in their new lives across Canada.",

  // Volunteer Preview
  "volunteer.tag": "Get Involved",
  "volunteer.title": "Join Our Community of Change-Makers",
  "volunteer.body1": "Whether you're a doctor, translator, fundraiser, or social media enthusiast — there's a place for you at CAF. Your skills can change lives.",
  "volunteer.body2": "We have volunteer opportunities for Canadians and Afghan diaspora members alike, both remote and in-person.",
  "volunteer.cta": "Become a Volunteer",
  "volunteer.otherWays": "Or explore other ways to help",
  "volunteer.apply": "Apply",
  "volunteer.location": "Location",

  // Donate Preview
  "donate.tag": "Make a Difference",
  "donate.title": "Your Donation, Their Future",
  "donate.subtitle": "100% of your donation goes directly to programs on the ground. We are a registered Canadian charity — all donations are tax-deductible.",
  "donate.tier.supporter": "Supporter",
  "donate.tier.champion": "Champion",
  "donate.tier.patron": "Patron",
  "donate.mostPopular": "Most Popular",
  "donate.highImpact": "High Impact",
  "donate.donate": "Donate",
  "donate.trust.charity": "Registered Canadian Charity",
  "donate.trust.transparent": "100% Transparent",
  "donate.trust.receipts": "Tax Receipts Issued",
  "donate.trust.secure": "Secure Processing",

  // Footer
  "footer.tagline": "Building bridges between Canada and Afghanistan through education, healthcare, and community development.",
  "footer.charity": "CRA Registered Charity #123456789",
  "footer.est": "Est. 2016",
  "footer.quickLinks": "Quick Links",
  "footer.getInvolved": "Get Involved",
  "footer.stayConnected": "Stay Connected",
  "footer.newsletter.desc": "Get monthly updates on our impact and how you can help.",
  "footer.newsletter.placeholder": "Your email address",
  "footer.newsletter.success": "Thank you for subscribing!",
  "footer.newsletter.privacy": "We respect your privacy. Unsubscribe anytime.",
  "footer.support": "Support available in:",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.accessibility": "Accessibility",
  "footer.admin": "Admin",
  "footer.copyright": "Canada Afghanistan Foundation. All rights reserved.",

  // Contact
  "contact.tag": "Get In Touch",
  "contact.title": "We'd Love to Hear From You",
  "contact.subtitle": "Have questions about our programs, want to partner with us, or need support? Reach out — we respond in English, Pashto, Dari, French, and German.",
  "contact.form.name": "Full Name",
  "contact.form.email": "Email Address",
  "contact.form.subject": "Subject",
  "contact.form.message": "Your Message",
  "contact.form.submit": "Send Message",
  "contact.form.sending": "Sending...",
  "contact.form.success": "Message sent! We'll get back to you within 48 hours.",
  "contact.info.address": "Address",
  "contact.info.email": "Email",
  "contact.info.phone": "Phone",
  "contact.info.hours": "Office Hours",

  // ========== MISSION PAGE ==========
  "missionPage.tag": "Our Mission",
  "missionPage.title": "A Mission Rooted in Hope, Driven by Action",
  "missionPage.subtitle": "The Canada Afghanistan Foundation exists to bridge the gap between compassionate Canadians and Afghan communities in need — creating sustainable change through education, healthcare, and community development.",
  "missionPage.who.tag": "Who We Are",
  "missionPage.who.title": "Building Bridges Between Two Nations",
  "missionPage.who.body1": "Founded in 2016 by Afghan-Canadian community leaders, CAF is a registered Canadian charity (CRA #123456789) dedicated to improving the lives of Afghan people through targeted, transparent, and impactful programs.",
  "missionPage.who.body2": "We believe that geography and conflict should never determine a child's access to education, a family's access to clean water, or a community's ability to thrive. Our work is guided by the principle that sustainable change comes from within communities — we empower, not replace.",
  "missionPage.who.body3": "With a volunteer network of 340+ dedicated individuals across Canada and Afghanistan, and partnerships with local Afghan NGOs, we ensure every dollar reaches those who need it most.",
  "missionPage.who.ctaProjects": "See Our Projects",
  "missionPage.who.ctaSupport": "Support Us",
  "missionPage.who.yearsBadge": "Years of Impact",
  "missionPage.values.tag": "What Guides Us",
  "missionPage.values.title": "Our Core Values",
  "missionPage.values.compassion": "Compassion",
  "missionPage.values.compassionDesc": "We act with empathy and care for every individual we serve, regardless of background or circumstance.",
  "missionPage.values.integrity": "Integrity",
  "missionPage.values.integrityDesc": "We operate with full financial transparency and accountability to our donors and the communities we serve.",
  "missionPage.values.collaboration": "Collaboration",
  "missionPage.values.collaborationDesc": "We partner with local Afghan organizations, Canadian institutions, and global NGOs to maximize impact.",
  "missionPage.values.sustainability": "Sustainability",
  "missionPage.values.sustainabilityDesc": "We design programs that empower communities to become self-sufficient and resilient over time.",
  "missionPage.values.equity": "Equity",
  "missionPage.values.equityDesc": "We prioritize the most vulnerable — women, children, and displaced families — in all our programs.",
  "missionPage.values.innovation": "Innovation",
  "missionPage.values.innovationDesc": "We continuously seek creative, evidence-based solutions to complex humanitarian challenges.",
  "missionPage.timeline.tag": "Our Journey",
  "missionPage.timeline.title": "8 Years of Impact",
  "missionPage.timeline.2016": "CAF founded in Ottawa by Afghan-Canadian community leaders",
  "missionPage.timeline.2017": "First girls education scholarship program launched in Kabul",
  "missionPage.timeline.2018": "Mobile health clinic program deployed in Nangarhar Province",
  "missionPage.timeline.2019": "Clean water initiative reaches 5,000 families in Helmand",
  "missionPage.timeline.2020": "COVID-19 emergency relief — distributed PPE and food to 3,000 families",
  "missionPage.timeline.2021": "Refugee resettlement program launched in Toronto and Ottawa",
  "missionPage.timeline.2022": "Vocational training centers opened in Herat and Mazar-i-Sharif",
  "missionPage.timeline.2023": "Expanded to 15 active projects across 8 Afghan provinces",
  "missionPage.timeline.2024": "2,500+ students supported; 18,000+ people with clean water access",
  "missionPage.cta.title": "Be Part of the Mission",
  "missionPage.cta.subtitle": "Whether you donate, volunteer, or simply spread the word — you are part of the change.",
  "missionPage.cta.donate": "Donate Now",
  "missionPage.cta.volunteer": "Volunteer With Us",

  // ========== PROJECTS PAGE ==========
  "projectsPage.tag": "What We Do",
  "projectsPage.title": "Our Projects",
  "projectsPage.subtitle": "From classrooms in Kabul to water wells in Helmand — every project is a step toward a better Afghanistan.",
  "projectsPage.filters.all": "All",
  "projectsPage.filters.education": "Education",
  "projectsPage.filters.healthcare": "Healthcare",
  "projectsPage.filters.infrastructure": "Infrastructure",
  "projectsPage.filters.community": "Community",
  "projectsPage.filters.humanitarian": "Humanitarian",
  "projectsPage.status.all": "All",
  "projectsPage.status.active": "Active",
  "projectsPage.status.completed": "Completed",
  "projectsPage.empty": "No projects found for this filter.",
  "projectsPage.details": "Details",
  "projectsPage.raised": "Raised",
  "projectsPage.badge.completed": "Completed",

  // ========== PROJECT DETAIL PAGE ==========
  "projectDetail.home": "Home",
  "projectDetail.projects": "Projects",
  "projectDetail.notFound": "Project Not Found",
  "projectDetail.notFound.back": "Back to Projects",
  "projectDetail.funding.title": "Funding Progress",
  "projectDetail.funding.raised": "raised of",
  "projectDetail.funding.goal": "goal",
  "projectDetail.funding.funded": "funded",
  "projectDetail.funding.cta": "Donate to This Project",
  "projectDetail.details.title": "Project Details",
  "projectDetail.details.category": "Category",
  "projectDetail.details.location": "Location",
  "projectDetail.details.beneficiaries": "Beneficiaries",
  "projectDetail.details.status": "Status",
  "projectDetail.details.statusActive": "Active",
  "projectDetail.details.statusCompleted": "Completed",
  "projectDetail.body1": "This initiative is part of CAF's broader commitment to creating sustainable, community-led development in Afghanistan. Our local partners on the ground ensure that resources are distributed equitably and that programs are culturally appropriate and effective.",
  "projectDetail.body2": "All funds raised go directly to program delivery. CAF maintains full financial transparency and provides regular impact reports to donors. Tax receipts are issued for all donations over $20 CAD.",
  "projectDetail.back": "Back to All Projects",
  "projectDetail.beneficiariesSuffix": "beneficiaries",

  // ========== VOLUNTEER PAGE ==========
  "volunteerPage.tag": "Get Involved",
  "volunteerPage.title": "Join Our Community of Change-Makers",
  "volunteerPage.subtitle": "Your skills, time, and passion can transform lives. Whether you're in Canada or abroad, there's a meaningful role for you at CAF.",
  "volunteerPage.positions.tag": "Open Positions",
  "volunteerPage.positions.title": "Current Volunteer Opportunities",
  "volunteerPage.stories.tag": "Volunteer Stories",
  "volunteerPage.stories.title": "Hear From Our Volunteers",
  "volunteerPage.apply.title": "Apply to Volunteer",
  "volunteerPage.apply.submitted": "Application Submitted!",
  "volunteerPage.apply.submittedDesc": "Thank you for your interest. Our team will contact you within 3-5 business days.",
  "volunteerPage.apply.close": "Close",
  "volunteerPage.form.name": "Full Name *",
  "volunteerPage.form.namePlaceholder": "Your full name",
  "volunteerPage.form.email": "Email Address *",
  "volunteerPage.form.emailPlaceholder": "your@email.com",
  "volunteerPage.form.message": "Why do you want to volunteer? *",
  "volunteerPage.form.messagePlaceholder": "Tell us about your background and motivation...",
  "volunteerPage.form.submit": "Submit Application",
  "volunteerPage.form.submitting": "Submitting...",
  "volunteerPage.spotsAvailable": "spot(s) available",
  "volunteerPage.applyNow": "Apply Now",

  // ========== DONATE PAGE ==========
  "donatePage.tag": "Make a Difference",
  "donatePage.title": "Donate to CAF",
  "donatePage.subtitle": "Your generosity directly funds education, healthcare, and community programs for Afghan families. Every dollar counts.",
  "donatePage.yourImpact": "Your Impact",
  "donatePage.howToDonate": "How to Donate",
  "donatePage.tier.friend.label": "Friend",
  "donatePage.tier.friend.impact": "Provides school supplies for 2 students",
  "donatePage.tier.supporter.label": "Supporter",
  "donatePage.tier.supporter.impact": "Provides school supplies for 5 students for one semester",
  "donatePage.tier.advocate.label": "Advocate",
  "donatePage.tier.advocate.impact": "Funds clean water access for a family for 2 months",
  "donatePage.tier.champion.label": "Champion",
  "donatePage.tier.champion.impact": "Funds a month of clean water access for a family of 6",
  "donatePage.tier.benefactor.label": "Benefactor",
  "donatePage.tier.benefactor.impact": "Covers medical care for 10 patients at our mobile clinic",
  "donatePage.tier.patron.label": "Patron",
  "donatePage.tier.patron.impact": "Sponsors a girl's full year of secondary school education",
  "donatePage.custom.label": "Custom Amount (CAD)",
  "donatePage.custom.placeholder": "Enter amount",
  "donatePage.custom.note": "For custom donations, please contact us directly to arrange payment.",
  "donatePage.custom.contact": "Contact Us",
  "donatePage.bank.title": "Bank Transfer",
  "donatePage.bank.desc": "Transfer directly to our Canadian bank account:",
  "donatePage.bank.name": "Canada Afghanistan Foundation",
  "donatePage.bank.bank": "Bank",
  "donatePage.bank.bankName": "Royal Bank of Canada (RBC)",
  "donatePage.bank.accountName": "Account Name",
  "donatePage.bank.accountNum": "Account #",
  "donatePage.bank.transit": "Transit #",
  "donatePage.bank.institution": "Institution #",
  "donatePage.bank.warning": "Important: Please include your full name and email in the transfer notes so we can issue your tax receipt.",
  "donatePage.cheque.title": "Cheque",
  "donatePage.cheque.desc": "Mail a cheque payable to:",
  "donatePage.cheque.warning": "Please write your email address on the back of the cheque to receive your tax receipt.",
  "donatePage.inperson.title": "In-Person",
  "donatePage.inperson.desc": "Visit our office during business hours:",
  "donatePage.inperson.note": "We accept cash, cheque, and debit/credit card in person.",
  "donatePage.tax.title": "Tax Receipts",
  "donatePage.tax.desc": "CAF is a registered Canadian charity (CRA #123456789). All donations over $20 CAD are eligible for a tax receipt, issued within 30 days of your donation.",
  "donatePage.trust.charity": "Registered Charity",
  "donatePage.trust.transparent": "100% Transparent",
  "donatePage.trust.secure": "Secure & Safe",
  "donatePage.trust.programs": "100% to Programs",
  "donatePage.bottom.title": "Questions About Donating?",
  "donatePage.bottom.subtitle": "Our team is happy to help you make the most impactful donation possible.",
  "donatePage.bottom.contact": "Contact Our Team",

  // ========== CONTACT PAGE ==========
  "contactPage.tag": "Get in Touch",
  "contactPage.title": "Contact & Support",
  "contactPage.subtitle": "Have a question, want to partner with us, or need support? We're here to help — in English, Pashto, and Dari.",
  "contactPage.form.title": "Send Us a Message",
  "contactPage.form.submitted": "Message Sent!",
  "contactPage.form.submittedDesc": "Thank you for reaching out. Our team will respond within 2-3 business days.",
  "contactPage.form.another": "Send Another Message",
  "contactPage.form.name": "Full Name *",
  "contactPage.form.namePlaceholder": "Your full name",
  "contactPage.form.email": "Email Address *",
  "contactPage.form.emailPlaceholder": "your@email.com",
  "contactPage.form.phone": "Phone Number",
  "contactPage.form.phonePlaceholder": "+1 (613) 555-0000",
  "contactPage.form.subject": "Subject *",
  "contactPage.form.subjectPlaceholder": "Select a subject",
  "contactPage.form.subjectOptions.general": "General Inquiry",
  "contactPage.form.subjectOptions.donation": "Donation Question",
  "contactPage.form.subjectOptions.volunteer": "Volunteer Application",
  "contactPage.form.subjectOptions.partnership": "Partnership Proposal",
  "contactPage.form.subjectOptions.media": "Media & Press",
  "contactPage.form.subjectOptions.tech": "Technical Support",
  "contactPage.form.subjectOptions.other": "Other",
  "contactPage.form.message": "Message *",
  "contactPage.form.messagePlaceholder": "How can we help you?",
  "contactPage.form.submit": "Send Message",
  "contactPage.form.sending": "Sending...",
  "contactPage.form.error": "Something went wrong. Please try again or email us directly.",
  "contactPage.form.charLimit": "Message must be 500 characters or less.",
  "contactPage.form.privacy": "We respect your privacy. Your information will never be shared with third parties.",
  "contactPage.office.title": "Our Office",
  "contactPage.office.address": "Address",
  "contactPage.office.addressValue": "123 Rideau Street, Suite 400\nOttawa, Ontario K1N 5Y1, Canada",
  "contactPage.office.hours": "Office Hours",
  "contactPage.office.hoursValue": "Mon – Fri: 9:00 AM – 5:00 PM EST",
  "contactPage.office.phone": "Phone",
  "contactPage.office.email": "Email",
  "contactPage.map.directions": "Get Directions",
  "contactPage.lang.title": "Multilingual Support",
  "contactPage.lang.desc": "We provide support in English, Pashto, and Dari. Please indicate your preferred language in your message.",

  // ========== STORIES PAGE ==========
  "storiesPage.tag": "Our Stories",
  "storiesPage.title": "Stories of Impact & Hope",
  "storiesPage.subtitle": "Read firsthand accounts from the field, meet the people behind our mission, and stay updated on the latest from CAF.",
  "storiesPage.filters.all": "All",
  "storiesPage.filters.fieldStories": "Field Stories",
  "storiesPage.filters.impactReports": "Impact Reports",
  "storiesPage.filters.volunteerVoices": "Volunteer Voices",
  "storiesPage.filters.news": "News & Updates",
  "storiesPage.empty": "No stories found for this category.",
  "storiesPage.readMore": "Read More",
  "storiesPage.backToStories": "Back to All Stories",
  "storiesPage.by": "by",
  "storiesPage.published": "Published",

  // Stories Preview (Home)
  "storiesPreview.tag": "From the Field",
  "storiesPreview.title": "Stories of Impact & Hope",
  "storiesPreview.subtitle": "Real stories from the communities we serve — told by the people living the change every day.",
  "storiesPreview.viewAll": "Read All Stories",

  // Photo Slider (Home)
  "photoSlider.tag": "In The Field",
  "photoSlider.title": "Our Work in Pictures",
  "photoSlider.subtitle": "See the impact of your support — real moments from our projects across Afghanistan and Canada.",
};

export default translations;